import { render, staticRenderFns } from "./AdmitCardHeader.vue?vue&type=template&id=9a6f1180&"
import script from "./AdmitCardHeader.vue?vue&type=script&lang=js&"
export * from "./AdmitCardHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports